var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.25 8.7L31.9333 5.9C31.4667 5.35 30.7833 5 30 5H10C9.21667 5 8.53333 5.35 8.08333 5.91667L5.76667 8.7C5.28333 9.28333 5 10.0167 5 10.8333V31.6667C5 33.5 6.48333 35 8.33333 35H31.6667C33.5 35 35 33.5 35 31.6667V10.8333C35 10.0167 34.7167 9.28333 34.25 8.7ZM20 15.8333L29.1667 25H23.3333V28.3333H16.6667V25H10.8333L20 15.8333ZM8.53333 8.33333L9.9 6.66667H29.9L31.45 8.33333H8.53333Z",
    fill: "url(#paint0_linear_1125_978)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_978",
    x1: 20,
    y1: 5,
    x2: 20,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBoxIcon);
export default __webpack_public_path__ + "static/media/arrowBoxIcon.8de549e76b85259712291c5d04a314f9.svg";
export { ForwardRef as ReactComponent };